/*
 * @Author: Teemo Ding
 * @Date: 2021-12-14 15:24:58
 * @LastEditTime: 2022-07-19 15:18:46
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/ShoppingCartTemplate/ShoppingCartTemplateDetail/ShoppingCartURL/index.tsx
 */
import { Button } from '@/src/components/Antd';
import Link from '@/src/components/Link/Link';
import CustomerSelectionNoPagination from '@/src/constrains/CustomerSelectionNoPagination';
import ModalHOC from '@/src/constrains/ModalHOC';
import { useI18n } from '@/src/hooks/useRouterChange';
import { notifyShoppingCartTemplate } from '@/src/request/order/shoppingCartTemplate';
import { copyToClip } from '@/src/tools/helper';
import { i18nGet, replaceI18nVariables } from '@/src/tools/tools';
import { useRequest } from 'ahooks';
import { message } from 'antd';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import { SectionWrapper } from 'src/components/Layouts';
import { ICategory } from 'src/types/common/template';
import SendTemplate from '../../../Components/SendTemplate';
import css from './css.module.less';
import { EnumSalesChannelMultiCurrency } from '@/src/types/server/params';

interface IParams {
  uuid: string;
}

const ShoppingCartUrl = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    modalOp,
    shoppingCartUrl,
    dbUuid,
    clickCount,
    appliedOrders,
    salesChannelUuid,
    disabled,
    disableCopy,
    timezoneInGmt,
  } = props;
  const {
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
    setWidth,
  } = modalOp;
  const [customer, setCustomer] = useState();
  const params = useParams<IParams>();
  const { uuid: shoppingCartTemplateUuid } = params;

  const { run: _notifyShoppingCartTemplate } = useRequest(
    (data) =>
      notifyShoppingCartTemplate(data, {
        [EnumSalesChannelMultiCurrency.multiCurrencyInParams]: true,
      }),
    {
      manual: true,
      onSuccess: () => {
        setShowModal(false);
        message.success(
          getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_notifymsgsuccess',
          ),
        );
      },
    },
  );
  const handleConfirmCustomer = (data) => {
    setCustomer(data);
    handleSendTemplate(data);
  };
  const handleNotifyCustomer = () => {
    setWidth(900);
    setShowModal(true);
    setModalTitle(
      getI18n(
        'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_handleNotifyCustomer_setModalTitle',
      ),
    );
    setModalContent(
      <CustomerSelectionNoPagination
        selected={customer}
        onCancel={onModalCancel}
        onConfirm={handleConfirmCustomer}
        dbUuid={dbUuid}
        okText={getI18n(
          'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_handleNotifyCustomer_setModalContent_okText',
        )}
        rowSelectionType='radio'
      />,
    );
  };

  const handleNotifyShoppingCartTemplate = (values, customerIndex) => {
    const data = {
      uuid: shoppingCartTemplateUuid,
      customerUuids: [get(customerIndex, 'uuid', '')],
      viaEmail: values.sendTo.includes('Email'),
      viaSms: values.sendTo.includes('Mobile'),
      emailTemplateUuid: values.emailTemplate,
      smsTemplateUuid: values.messageTemplate,
    };
    _notifyShoppingCartTemplate(data);
  };
  const handleSendTemplate = (data) => {
    const customerIndex = get(data, '[0]');
    setWidth(600);
    // setShowModal(true);
    setModalTitle(getI18n('general.notifyCustomer'));
    setShowModal(true);
    setModalContent(
      <SendTemplate
        buyerEmail={(customerIndex || {}).email}
        buyerPhoneNo={
          (customerIndex || {}).mobile
            ? `+ ${(customerIndex || {}).areaCode} ${
                (customerIndex || {}).mobile
              }`
            : ''
        }
        salesChannelUuid={salesChannelUuid}
        onModalCancel={onModalCancel}
        onConfirm={(values) =>
          handleNotifyShoppingCartTemplate(values, customerIndex)
        }
        okText={getI18n('general.send')}
        category={ICategory.CreateShoppingCart}
        showBack
        onBack={handleNotifyCustomer}
      />,
    );
  };

  const copyURl = () => {
    copyToClip(shoppingCartUrl);
    message.success(
      getI18n(
        'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_copyURl_msgsuccess',
      ),
    );
  };

  return (
    <SectionWrapper
      title={getI18n(
        'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_return_title',
      )}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      <div className={css.header}>
        <p className={css.url}>{shoppingCartUrl}</p>
        <Button type='primary' ghost onClick={copyURl} disabled={disableCopy}>
          {getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_return_header_copyurl',
          )}
        </Button>
        <Button
          className={css.notifyCustomer}
          type='primary'
          onClick={handleNotifyCustomer}
          disabled={disabled}>
          {getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_return_header_notify',
          )}
        </Button>
      </div>
      <div className={css.item}>
        <h3>
          {getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_return_clickcount_item',
          )}
        </h3>
        <p>{clickCount}</p>
      </div>
      <div className={css.item}>
        <h3>
          {getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_return_orderapplied_item',
          )}
        </h3>
        <div className={css.orderApplied}>
          {(appliedOrders || []).map((item, index) => (
            <div key={index} className={css.orderAppliedItem}>
              <Link to={`/order/${item.uuid}`}>#{item.orderNo}</Link>
              <p>
                {item.createdDate}{' '}
                {replaceI18nVariables(
                  getI18n(
                    'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_ShoppingCartURL_return_utc',
                  ),
                  timezoneInGmt,
                )}
              </p>
            </div>
          ))}
          {/* <div className={css.orderAppliedItem}>
            <Link to='/'>#01928192812</Link>
            <p>2021-11-10 22:00 (UTC+8)</p>
          </div>
          <div className={css.orderAppliedItem}>
            <Link to='/'>#01928192812</Link>
            <p>2021-11-10 22:00 (UTC+8)</p>
          </div>
          <div className={css.orderAppliedItem}>
            <Link to='/'>#01928192812</Link>
            <p>2021-11-10 22:00 (UTC+8)</p>
          </div>
          <div className={css.orderAppliedItem}>
            <Link to='/'>#01928192812</Link>
            <p>2021-11-10 22:00 (UTC+8)</p>
          </div>
          <div className={css.orderAppliedItem}>
            <Link to='/'>#01928192812</Link>
            <p>2021-11-10 22:00 (UTC+8)</p>
          </div>
          <div className={css.orderAppliedItem}>
            <Link to='/'>#01928192812</Link>
            <p>2021-11-10 22:00 (UTC+8)</p>
          </div>
          <div className={css.orderAppliedItem}>
            <Link to='/'>#01928192812</Link>
            <p>2021-11-10 22:00 (UTC+8)</p>
          </div>
          <div className={css.orderAppliedItem}>
            <Link to='/'>#01928192812</Link>
            <p>2021-11-10 22:00 (UTC+8)</p>
          </div> */}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default ModalHOC(ShoppingCartUrl);
